<template>

  <div class="content" v-loading="loading">

    <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
    <div class="mb-3 d-flex">
      <router-link :to="{ name: 'Settings' }">
        <el-button plain size="small" class=" mr-5"><span class="el-icon-arrow-left"></span> Back to Settings</el-button>
      </router-link>

      <el-button-group v-if="rooms && rooms.length">
        <el-button v-for="room in rooms" :key="room._id" @click="selectRoom(room)" :type="room._id === (selectedRoom && selectedRoom._id) ? 'primary' : ''" size="small">{{room.title}}</el-button>
      </el-button-group>
      <el-button-group>
      <el-button type="success" size="small" @click="createNewRoom">
        <i class="el-icon-plus"></i>
        Add room
      </el-button>
      <el-button v-if="selectedRoom" type="danger" size="small" @click="deleteRoom(selectedRoom)">
        <i class="el-icon-delete"></i>
        Delete current room
      </el-button>
      </el-button-group>
    </div>

    <manage-room v-if="selectedRoom" :room="selectedRoom" @saved="save" />

    <el-dialog :title="'Create new room'" :visible.sync="showCreateRoom">

      <create-room-dialog :item="newRoom" @create="onCreateRoom"></create-room-dialog>

    </el-dialog>
  </div>
</template>
<script>
import ManageRoom from './ManageRoom';
import CreateRoomDialog from '../components/CreateRoomDialog';

export default {
  components: {
    ManageRoom,
    CreateRoomDialog
  },
  computed: {
    accountSettings() {
      return this.$store.state.accountSettings;
    }
  },
  data() {
    return {
      newRoom: {},
      showCreateRoom: false,
      loading: false,
      rooms: [],
      selectedRoom: null
    };
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch('getAccountSettings');

    if (this.accountSettings.reservation && this.accountSettings.reservation.rooms) {
      this.rooms = this.accountSettings.reservation.rooms;
    } else {
      this.rooms = [];
    }
    this.selectedRoom = this.rooms[0];
    this.loading = false;
  },
  methods: {
    selectRoom(room) {
      this.selectedRoom = null;
      setTimeout(() => {
        this.selectedRoom = room;
      }, 100);
    },

    createNewRoom() {
      this.newRoom = {};
      this.showCreateRoom = true;
    },

    onCreateRoom() {
      this.newRoom._id = Math.random();
      this.newRoom.settings = '';
      this.rooms.push(this.newRoom);
      this.selectedRoom = this.newRoom;
      this.showCreateRoom = false;

      this.save();
    },

    async save() {
      await this.$store.dispatch('saveReservations', this.accountSettings.reservation);
    },
    async deleteRoom(room) {
      try {
        await this.$confirm('This will permanently delete the room. Continue?', 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        });
        this.rooms = this.rooms.filter(room => room._id !== this.selectedRoom._id);
        this.accountSettings.reservation.rooms = this.rooms;
        if (this.rooms.length) {
          this.selectedRoom = this.rooms[ 0 ];
        } else {
          this.selectedRoom = null;
        }
        this.save();
      } catch (err) {
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ManageRooms.vue?52ac0620